import { ActionIcon, Button, Group } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import React from 'react'
import AppIcon from './AppIcon'
import { themeCfg } from '../../theme/theme'

interface CustomProps extends React.ComponentPropsWithoutRef<typeof Button> {
  preset?: 'back' | 'save' | 'remove' | 'cancel'
  breakpoint?: string
  label?: string
  entity?: string
  icon?: string
  invisible?: boolean
  disabled?: boolean
  bg?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

const AppButton = ({
  preset,
  breakpoint = themeCfg?.breakpoint,
  label,
  entity,
  icon,
  invisible = false,
  disabled = false,
  bg = 'primary',
  onClick,
  ...otherProps
}: CustomProps) => {
  const { t, i18n } = useTranslation()

  const processProps = () => {
    if (preset === 'back')
      return {
        variant: 'outline',
        c: 'primary',
      }
    if (preset === 'save')
      return {
        variant: 'solid',
        bg: 'moure-orange',
      }
    if (preset === 'remove')
      return {
        variant: 'solid',
        bg: 'red.9',
      }
    if (preset === 'cancel')
      return {
        variant: 'light',
      }
    if (preset === 'reset')
      return {
        variant: 'light',
      }
    if (preset === 'synch')
      return {
        variant: 'solid',
        bg: 'moure-orange',
      }
    if (preset === 'add')
      return {
        variant: 'solid',
        bg: 'moure-orange',
      }
    if (preset === 'upload')
      return {
        variant: 'solid',
        bg: 'primary',
      }
    if (preset === 'send')
      return {
        variant: 'solid',
        bg: 'moure-orange',
      }
    return {
      bg,
    }
  }

  const customProps = processProps()
  if (invisible)
    return themeCfg?.debug ? <Group fz="80%">h.button</Group> : null
  return (
    <>
      <ActionIcon
        {...otherProps}
        {...customProps}
        disabled={disabled}
        size="lg"
        onClick={onClick}
        hiddenFrom={breakpoint}
      >
        <AppIcon icon={preset || entity || icon} />
      </ActionIcon>
      <Button
        {...otherProps}
        {...customProps}
        disabled={disabled}
        onClick={onClick}
        visibleFrom={breakpoint}
        leftSection={<AppIcon icon={preset || entity || icon} />}
        rightSection={t(label) || t(preset)}
      />
    </>
  )
}

export default AppButton
